// * import third party
import { Text, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';

export default function TableTemplate({ tableHeadLists = [], tableData = [], isPlainTable = false, ...props }) {
    if (!tableHeadLists || !tableData) return <Text>There was an error displaying your data!</Text>;

    const tableHeadMapping = () => {
        return tableHeadLists.map((value) => (
            <Th
                textTransform={'none'}
                fontWeight={isPlainTable ? 'normal' : 'bold'}
                color={'semantic.600'}
                fontFamily={'inherit'}
                fontSize={'14px'}
                p={'12px'}
                letterSpacing={'normal'}
                width={value.width ?? '200px'}
                textAlign={value.align ?? 'left'}
            >
                {value.title}
            </Th>
        ));
    };

    const tableBodyMapping = () => {
        return tableData.map((data) => (
            <Tr>
                {tableHeadLists.map((list) => (
                    <Td p={'12px'} fontSize={'14px'} textAlign={list.align ?? 'left'} verticalAlign={'top'}>
                        {list.tableDataList({ value: data[list.key] })}
                    </Td>
                ))}
            </Tr>
        ));
    };

    return (
        <Table variant="simple" minW={'800px'} {...props}>
            <Thead>
                <Tr>{tableHeadMapping()}</Tr>
            </Thead>

            <Tbody>{tableBodyMapping()}</Tbody>
        </Table>
    );
}
